import { post, postJson, get,put } from '../axios'

const RESOURCE_BASE_PATH = '/tbPhoneBinding';

//获取当前登录账号信息
export const querySellerSetting = p => get(`${RESOURCE_BASE_PATH}/accountSetting`, p);

//更新当前登录账号信息
export const updateSellerSetting = p => put(`${RESOURCE_BASE_PATH}/accountSetting`, p);


// 获取验证码
export const checkCodeSet = p => get(`${RESOURCE_BASE_PATH}/checkCode`, p);

// 更新店铺绑定的手机号码
export const updateShopMobile = p => put(`${RESOURCE_BASE_PATH}/updateShopMobile`, p);
